import { render, staticRenderFns } from "./project-page.vue?vue&type=template&id=2a1a865e&"
import script from "./project-page.vue?vue&type=script&lang=js&"
export * from "./project-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports